/*
|--------------------------------------------------------------------------
| Views: Grid Infinite
|--------------------------------------------------------------------------
*/

/**
 * Grid Infinite
 * @namespace
 */
__gh__webApp.views.gridInfinite = {

	"callbacks": function(bucket){
		__gh__webApp.utilities.infiniteScroll.init();
	},

	"getSubView": function(bucket){
		// Prep Items
		bucket.view.name 				= "buckets/gridInfinite/default";
		bucket.view.infiniteScroll.view	= "buckets/gridInfinite/partials/_infinite";
		return bucket;

	}

};